import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/question.svg'
import _imports_1 from '@/assets/printing-assets/issue-4.svg'


_pushScopeId("data-v-9bc51d6e")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "title" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createElementVNode("span", null, "Alignment Wizard")
  ])
], -1)
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { id: "alignment-steps" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "step" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "alignment-number" }, [
    /*#__PURE__*/_createElementVNode("span", null, "1")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-wrap" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Measure"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" Using a ruler measure the distance between the edge of your artwork and the edge of the label. If you need a ruler you can download one "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.sheetlabels.com/resources/mm_files/hc/533776.pdf",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Here"),
      /*#__PURE__*/_createTextVNode(". We recommend measuring the offset of the top and left edges and using these measurements to configure your template. ")
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "step" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "alignment-number" }, [
    /*#__PURE__*/_createElementVNode("span", null, "2")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-wrap" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Configure"),
    /*#__PURE__*/_createElementVNode("p", null, " Configure the template to your printer using the measurements you gathered from your test sheet. For example, if your template is 1/32\" too high, and 1/16\" too far left, you'll adjust your template 1/32\" down and 1/16\" to the right. Once you've input your values you can download and print your corrected template. Repeat steps 1 and 2 as necessary until your template is correctly configured. ")
  ])
], -1)
const _hoisted_6 = { id: "adjust-wrap" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Printing Adjustments", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Select how far to move your template in each direction", -1)
const _hoisted_9 = { id: "adjust-inputs" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "up-adjust" }, "Up", -1)
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "down-adjust" }, "Down", -1)
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "left-adjust" }, "Left", -1)
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "right-adjust" }, "Right", -1)
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  id: "img-wrap"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  id: "issue-img"
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { id: "download-print" }
const _hoisted_22 = {
  key: 0,
  version: "1.1",
  id: "loader-1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "40px",
  height: "40px",
  viewBox: "0 0 50 50",
  style: {"enable-background":"new 0 0 50 50"},
  "xml:space": "preserve"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#ff6c00",
  d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
}, [
  /*#__PURE__*/_createElementVNode("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "rotate",
    from: "0 25 25",
    to: "360 25 25",
    dur: "2s",
    repeatCount: "indefinite"
  })
], -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  id: "img-wrap"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  id: "issue-img"
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.bounceTransition, "modal-body"])
      }, [
        _createElementVNode("div", {
          class: "close-svg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createVNode(_component_CloseSVG, {
            propId: 'print-close',
            fillColor: '#f7f9fc'
          })
        ]),
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _hoisted_10,
                  _createElementVNode("select", {
                    id: "up-adjust",
                    name: "up-adjust",
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args))),
                    disabled: _ctx.upDisable
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adjustments, (adjustments, idx) => {
                      return (_openBlock(), _createElementBlock("option", { key: idx }, _toDisplayString(adjustments), 1))
                    }), 128))
                  ], 40, _hoisted_11)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_12,
                  _createElementVNode("select", {
                    id: "down-adjust",
                    name: "down-adjust",
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args))),
                    disabled: _ctx.downDisable
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adjustments, (adjustments, idx) => {
                      return (_openBlock(), _createElementBlock("option", { key: idx }, _toDisplayString(adjustments), 1))
                    }), 128))
                  ], 40, _hoisted_13)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_14,
                  _createElementVNode("select", {
                    id: "left-adjust",
                    name: "left-adjust",
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args))),
                    disabled: _ctx.leftDisable
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adjustments, (adjustments, idx) => {
                      return (_openBlock(), _createElementBlock("option", { key: idx }, _toDisplayString(adjustments), 1))
                    }), 128))
                  ], 40, _hoisted_15)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_16,
                  _createElementVNode("select", {
                    id: "right-adjust",
                    name: "right-adjust",
                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args))),
                    disabled: _ctx.rightDisable
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adjustments, (adjustments, idx) => {
                      return (_openBlock(), _createElementBlock("option", { key: idx }, _toDisplayString(adjustments), 1))
                    }), 128))
                  ], 40, _hoisted_17)
                ])
              ])
            ]),
            (_ctx.clientDimensions.width <= 900)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_22, _hoisted_24))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    id: "print-pdf",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.setupLabel && _ctx.setupLabel(...args)))
                  }, "Download & Print a Configured PDF"))
            ])
          ]),
          (_ctx.clientDimensions.width > 900)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ], 2)
  ]))
}